<template>
  <DataTable url="companies" edit-url="edit-company-form" />
</template>
<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/DataTable.vue";
export default {
  name: "template-index",
  emits: ["setBreadcrumb"],
  components: { DataTable },
  data() {
    return {
      breadcrumb: [{ text: "Empresas", link: { name: "companies" } }],
    };
  },
  created() {
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
